import React, { useEffect, useState } from "react";
import PureHeader from "../../../shared/FrontHeader/PureHeader";
import BreadCrumb from "../../../shared/BreadCrumb";
import { useStepType } from "../../../../utils/type";
import { useStep } from "react-hooks-helper";
import PanierValidStep from "./steps/PanierValidStep";
import AdresseLivraison from "./steps/AdresseLivraison";
import ModePaiement from "./steps/ModePaiement";
import UseAddOrUpdateOrderForm from "./requestForm/UseAddOrUpdateOrderForm";
import { useAppSelector } from "../../../../redux/hook";
import ConnexionModal from "../../../shared/FrontHeader/modal/ConnexionModal";
import { useGetVendeurByApiKeyQuery } from "../../../../utils/api/product/product.api";
import { VendeurApikey } from "../../../../utils/http";
import { formatCurrency } from "../../../../utils/Utils";

const steps = [
  { id: "panier-validation", Component: PanierValidStep },
  { id: "address-livraison", Component: AdresseLivraison },
  { id: "mode-paiement", Component: ModePaiement },
];
const tabs = ["1", "2", "3"];

function ValidateCommand() {
  const { user } = useAppSelector((s) => s?.user);
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);
  const [modalConnexion, setModalConnexion] = useState(false);
  const { cartItems, totalAmount } = useAppSelector((state) => state.cart);

  const {
    step,
    navigation: { next, previous },
    index,
  }: useStepType = useStep({ initialStep: 0, steps });
  const { Component } = step;

  const {
    register,
    onSubmit,
    isLoading,
    errors,
    handleChangePhone,
    phone,
    onChangeAdresse,
    adresse,
    setValue,
  } = UseAddOrUpdateOrderForm(next, previous);

  useEffect(() => {
    if (user?.id) {
      setValue("telephone", user?.telephone);
      setValue("adresse", user?.adresse);
      setValue("user", user?.id);
      setValue("step", 1);
    }
  }, [user, setValue]);

  useEffect(() => {
    const code_commande: number | string = new Date().getTime();
    setValue("code_commande", code_commande.toString());
  }, [setValue]);

  useEffect(() => {
    const produitVisiteur = cartItems?.map((x) => ({
      produit: x?.produit?.id || x?.produit,
      prix: x?.prix > 0 ? x?.prix : undefined,
      quantite: x?.quantite,
      variations: x?.variations?.map((v) => v?.id).filter((id) => id != null),
    }));

    setValue("vendeur", cartItems[0]?.vendeur);
    setValue("produits", produitVisiteur);
    setValue("montant_total", totalAmount);
  }, [cartItems, setValue, totalAmount]);

  const precedent = () => {
    setValue("step", 1);
    setValue("mode_de_paiement", "");
    previous();
  };

  return (
    <div className="landing-page-component">
      <PureHeader />
      <div className="page-content pb-5 pb-5">
        <div className="container pt-4">
          {index === 0 && (
            <BreadCrumb pageName="mon panier" secondPage="valider mon panier" />
          )}
          {index === 1 && (
            <BreadCrumb pageName="mon panier" secondPage="Livraison" />
          )}
          {index === 2 && (
            <BreadCrumb pageName="mon panier" secondPage="Finaliser" />
          )}
          <div className="validate-command-content pt-5 pb-5">
            <div className="row row-validate">
              <div className="col-lg-9 validate-wrapper">
                <form onSubmit={onSubmit} id="validate-form">
                  <div className="tabs-wrapper pb-4">
                    <div className="tabs-stepper">
                      <ul className="tabs-container">
                        {tabs.map((tab, key) => (
                          <li
                            key={tab}
                            className={`
                              tab-item it${key}
                              ${index === key ? "tab-item-active" : ""}
                              ${index === 2 ? "eas_bg" : ""}
                            `}
                          >
                            {tab}
                            {key === 0 && (
                              <span className="tab-indicator">Panier</span>
                            )}
                            {key === 1 && (
                              <span className="tab-indicator">Livraison</span>
                            )}
                            {key === 2 && (
                              <span className="tab-indicator">Finaliser</span>
                            )}
                          </li>
                        ))}
                      </ul>
                      <div
                        className="progress validate-progress"
                        aria-hidden="true"
                      >
                        <div
                          className={`progress-bar custom-progress validate-progress-bar--step-${index}`}
                        />
                      </div>
                    </div>
                  </div>
                  <Component
                    register={register}
                    errors={errors}
                    handleChangePhone={handleChangePhone}
                    phone={phone}
                    vendeur={vendeur}
                    onChangeAdresse={onChangeAdresse}
                    adresse={adresse}
                  />
                  <div className="action-btn-content d-flex justify-content-end align-items-center gap-3 pt-4">
                    {index >= 1 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn validate-go-back-btn"
                        type="button"
                        onClick={precedent}
                      >
                        Précédent
                      </button>
                    )}
                    {index === 0 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn parcours-submit-btn"
                        type="button"
                        onClick={() => next()}
                      >
                        Suivant
                      </button>
                    )}
                    {index === 1 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn parcours-submit-btn"
                        type="submit"
                      >
                        Suivant
                      </button>
                    )}
                    {index === 2 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn parcours-submit-btn "
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? "Validation ..." : "Valider ma commande"}
                      </button>
                    )}
                  </div>
                </form>
              </div>

              <div className="col-lg-3">
                <div className="cart-card">
                  <h1 className="title pb-4">Total du panier</h1>
                  <div className="separator"></div>
                  <div className="total d-flex align-items-center justify-content-between pt-3">
                    <span className="sm-title">TOTAL</span>
                    <span className="sm-value total">
                      {formatCurrency(totalAmount, vendeur?.devise)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConnexionModal
        modalConnexion={modalConnexion}
        setModalConnexion={setModalConnexion}
      />

      <div className="mobile-bottom-bar">
        <div>
          <div className="total-label">Total</div>
          <div className="total-amount">
            {formatCurrency(totalAmount, vendeur?.devise)}
          </div>
        </div>
        <div className="bnt-section">
          {index === 0 && cartItems.length > 0 && (
            <button
              className="step-action-btn parcours-submit-btn"
              type="button"
              onClick={() => next()}
            >
              Suivant →
            </button>
          )}
          {index === 1 && cartItems.length > 0 && (
            <button
              className="step-action-btn parcours-submit-btn"
              type="submit"
              form="validate-form"
            >
              Suivant →
            </button>
          )}
          {index === 2 && cartItems.length > 0 && (
            <button
              className="step-action-btn parcours-submit-btn"
              type="submit"
              form="validate-form"
              disabled={isLoading}
            >
              {isLoading ? "Validation ..." : "Valider →"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ValidateCommand;
